import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import H1 from 'UIComponents/elements/headings/H1';
import UIImage from 'UIComponents/image/UIImage';
import { getPrimaryButtonStyle, getPrimaryButtonHoverStyle
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from 'MeetingsLib/utils/color';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import BookingFormField from 'MeetingsLib/components/input/BookingFormField';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { fetchPublicAvailabilityInfoForOwner as fetchBookInfoForOwner, fetchMeetingsUserForContactOwnerPrioritization as fetchMeetingsUser
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from 'MeetingsLib/redux/actions/BookActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getStagedPrefillEmail } from 'MeetingsLib/selectors/PrefillSelectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import CompanyLogo, { COMPANY_LOGO_USE
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from 'MeetingsLib/components/decorative/CompanyLogo';
import { useEmailValidation } from '../../hooks/useEmailValidation';
import { DataFetchingClient } from 'data-fetching-client';
import debounce from 'transmute/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const client = new DataFetchingClient();
const EmailForm = ({
  compact,
  logoUrl,
  useCompanyLogo,
  title,
  description,
  meetingChangeId,
  setEmailForm,
  branding,
  EmailFormMarker,
  prefillEmail,
  fetchPublicAvailabilityInfoForOwner,
  fetchMeetingsUserForContactOwnerPrioritization
}) => {
  const [buttonHover, setButtonHover] = useState(false);

  // We use below state to properly validate email field
  // against api to see if the domain is valid or not
  const [email, setEmail] = useState(prefillEmail);
  const [emailToValidate, setEmailToValidate] = useState('');
  const debouncedEmailToValidateChange = useMemo(() => debounce(500, nextVal => setEmailToValidate(nextVal)), [setEmailToValidate]);
  const isEmailInValidFormat = useCallback(() => {
    return Boolean(email && EmailAddressPattern.test(email));
  }, [email]);
  useEffect(() => {
    if (isEmailInValidFormat()) {
      debouncedEmailToValidateChange(email);
    }
  }, [debouncedEmailToValidateChange, email, isEmailInValidFormat]);
  const {
    isValid: emailIsValid,
    loading: isValidatingEmail
  } = useEmailValidation({
    email: emailToValidate,
    shouldSkip: false,
    client
  });
  const getEmailIsValid = useCallback(() => {
    return isValidatingEmail ? false : emailIsValid;
  }, [emailIsValid, isValidatingEmail]);
  const onEmailChange = (fieldName, newEmail) => {
    setEmail(newEmail);
  };
  const onMouseEnter = useCallback(() => {
    setButtonHover(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    setButtonHover(false);
  }, []);
  const getValidation = useCallback(() => {
    if (getEmailIsValid()) {
      return false;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "prebook.details.errorHelper.email"
    });
  }, [getEmailIsValid]);
  const getClassNames = useCallback(() => {
    return 'email-form p-all-5' + (compact ? " compact" : "");
  }, [compact]);
  const handleEmailSubmit = e => {
    e.preventDefault();
    setEmailForm(email);
    if (meetingChangeId) {
      fetchPublicAvailabilityInfoForOwner({
        email,
        meetingChangeId
      });
    } else {
      fetchPublicAvailabilityInfoForOwner({
        email
      });
    }
    fetchMeetingsUserForContactOwnerPrioritization(email);
  };
  const renderButton = () => {
    const style = buttonHover ? getPrimaryButtonHoverStyle(branding.primaryColor) : getPrimaryButtonStyle(branding.primaryColor);
    const isValid = getEmailIsValid();
    return /*#__PURE__*/_jsx("div", {
      className: "text-center m-top-5",
      children: /*#__PURE__*/_jsx(PreviewContext.Consumer, {
        children: isPreview => /*#__PURE__*/_jsx(UIButton, {
          style: style,
          use: "primary",
          disabled: !isValid,
          onClick: e => !isPreview && handleEmailSubmit(e),
          size: "medium",
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "emailForm.button"
          })
        })
      })
    });
  };
  const renderAvatar = () => {
    if (!useCompanyLogo && !logoUrl) {
      return /*#__PURE__*/_jsx(UIIllustration, {
        name: "meetings",
        width: "60%"
      });
    } else if (useCompanyLogo) {
      return /*#__PURE__*/_jsx("div", {
        className: "text-center m-top-4 m-x-14",
        children: /*#__PURE__*/_jsx(CompanyLogo, {
          branding: branding,
          use: COMPANY_LOGO_USE.EMAIL_FORM,
          heightOverride: "200px"
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {
        className: "text-center m-top-4",
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          shape: "circle",
          width: 200,
          height: 200,
          style: {
            margin: 'auto'
          }
        })
      });
    }
  };
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: "around",
    className: getClassNames(),
    style: {
      borderColor: branding.primaryColor || undefined
    },
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        maxWidth: '350px'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-center m-top-4",
        children: [renderAvatar(), /*#__PURE__*/_jsx(H1, {
          className: "m-y-2",
          children: title || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "emailForm.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-4",
          children: description || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "emailForm.text"
          })
        })]
      }), /*#__PURE__*/_jsx(BookingFormField, {
        fieldName: "email",
        fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emailForm.placeholder"
        }),
        validation: getValidation(),
        fieldValue: email,
        isRequired: true,
        setFormValue: onEmailChange,
        autocomplete: "on"
      }), renderButton(), /*#__PURE__*/_jsx(EmailFormMarker, {})]
    })
  });
};
export default connect(state => ({
  prefillEmail: getStagedPrefillEmail(state)
}), Object.assign({}, FormActions, {
  fetchPublicAvailabilityInfoForOwner: fetchBookInfoForOwner,
  fetchMeetingsUserForContactOwnerPrioritization: fetchMeetingsUser
}))(EmailForm);